import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import styles from './style.module.scss';

const ToolTip = ({ items }) => {

    const [open, setOpen] = useState(false);

    return <div className={styles.container}>
        <div className={styles.button} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}></div>
        <div className={`${styles.content} ${open ? styles.show : undefined}`}>
            {
                items.map(item => {
                    if (item.to !== undefined) {
                        return <Link to={item.to} state={item.params} className={styles.item}>{item.label}</Link>
                    } else if (item.onClick !== undefined) {
                        return <div className={styles.item} onClick={item.onClick}>{item.label}</div>
                    }
                })
            }
        </div>
    </div>


}

export default ToolTip;